import { RowDataUpdatedEvent } from 'ag-grid-community';
import { HttpErrorResponse } from '@angular/common/http';

export interface CustomRowLoadingStartedEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'rowLoadingStarted';
}

export interface CustomFilteredTotalUpdatedEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'filteredTotalUpdated';
  filteredTotal: number | null;
  noMatches: boolean;
}

export interface CustomRowDataLoadingFailedEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'rowDataLoadingFailed';
  error: HttpErrorResponse;
  initialPageError: boolean;
}

export interface CustomRowDataLoadingSuccessEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'rowDataLoadingSuccess';
  requestStartRow: number;
  requestEndRow: number;
  total?: number;
}

export interface CustomRowDataPinnedRowsAddedEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'rowDataPinnedRowsAdded';
  rowsAdded: number;
}

export interface CustomRetryRowLoadingEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'rowRetryLoading';
}

export interface CustomReloadAppEvent extends RowDataUpdatedEvent {
  type: 'rowDataUpdated';
  readonly customType: 'reloadApp';
}

export type CustomRowDataUpdatedEvent =
  | CustomRowLoadingStartedEvent
  | CustomFilteredTotalUpdatedEvent
  | CustomRowDataLoadingFailedEvent
  | CustomRowDataLoadingSuccessEvent
  | CustomRetryRowLoadingEvent
  | CustomRowDataPinnedRowsAddedEvent
  | CustomReloadAppEvent;

export function isCustomRowDataUpdatedEvent(event: CustomRowDataUpdatedEvent | RowDataUpdatedEvent): event is CustomRowDataUpdatedEvent {
  return typeof (<CustomRowDataUpdatedEvent>event).customType === 'string';
}
